const styles = theme => ({
  questionsContainer: {
    marginBottom: '10px',
    '& > * > * > *': {
      marginBottom: '10px',
    },
  },
  viewAllButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  btnViewAll: {
    width: '136px',
    height: '40px',
    borderRadius: '12px',
    border: 'solid 1px #004E98',
    color:'#004E98',
    marginTop: '30px'
  },
  txtViewAll: {
    fontFamily: 'Univia Pro',
    color: '#004E98',
    textTransform: 'capitalize'
  },
  label: {
    fontSize: '14px'
  },
  faqtabs: {
    marginBottom: '90px'
  },
  faqtablabel: {
    fontFamily: 'Univia Pro',
    color: '#191C30',
    fontSize: '15px',
    lineHeight: '24px',
    opacity: 1,
    fontWeight: 'bold',
    textTransform: 'none',
    width:'100px'
  },
  tabSelected: {
    color: '#015099'
  },
  tabsIndicator: {
    backgroundColor: '#015099'
  }
 
});

export default styles;

